import React, { useEffect } from "react";

import {
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { PublicRoute } from "./PublicRoute";
import { PriveteRoute } from "./PrivateRoute";
import { LoginScreen } from "../components/login/LoginScreen";
import { startCheking } from "../actions/auth";
import { Loader } from "../components/loader/Loader";
import { BodyTemplate } from "../components/templates/BodyTemplate";

export const AppRouter = () => {
  const dispatch = useDispatch();
  const {checking} = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(startCheking())
  }, [dispatch])

  const isAuthenticated = localStorage.getItem('token') || false;
  return (
    <Router>
      {
        checking ? <Loader />
        : <Switch>
          <PublicRoute  
              path="/login" 
              component={LoginScreen}
              isAuthenticated={!!isAuthenticated}
          />
          <PriveteRoute 
              path="/"
              component={BodyTemplate}
              isAuthenticated={!!isAuthenticated}
          />
          <Redirect to="/"/>
        </Switch>
      }
    </Router>
  );
}